module.exports = __webpack_public_path__ + "static/media/calendarNew.66735f71.svg";